/*
 * @Author: yidan.chen
 * @Date: 2025-02-10 15:55:32
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-03-13 15:23:31
 */
import { commonServerInstance, downloadInstance } from '@/utilities/instances'

export interface IQuarantineStatement {
  partner_id: string // Select from fetchPartners
  tracking_number: string
  invoice_number: string
  start_date: string
  end_date: string
  is_fixed: boolean
  status: string // Select from fetchQuarantineOrderStatus
  per_page: string
  page: string
}

export const fetchQuarantineStatement = async (query: IQuarantineStatement) => {
  const response = await commonServerInstance.get('/settle/quarantine/orders', {
    params: query
  })
  return response?.data?.data
}

export const fetchQuarantineOrderStatus = async () => {
  const response = await commonServerInstance.get('/settle/quarantine/status')
  return response?.data?.data
}

export const downloadQuarantineStatement = async (
  params: Partial<IQuarantineStatement> & { ids: string }
) => {
  try {
    const response = await downloadInstance.get('/settle/quarantine/download', {
      params
    })
    const contentDisposition = response.headers['content-disposition']
    let filename = 'quarantine_shipments.xlsx'

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+?)"|filename=(.+)/)
      if (match) {
        filename = match[1] || match[2]
      }
    }
    const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = fileUrl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(fileUrl)
    document.body.removeChild(link)

    return fileUrl
  } catch (error) {
    throw error
  }
}

export const uploadQuarantineStatement = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const response = await commonServerInstance.post(
    '/settle/quarantine/upload',
    formData,
    {
      timeout: 0
    }
  )
  return response
}

export const auditQuarantineStatement = async (
  params: {
    ids: string
    action: string
  } & Partial<IQuarantineStatement>
) => {
  const response = await commonServerInstance.post(
    '/settle/quarantine/review',
    params
  )
  return response
}
